// Central helper for translating the numeric player_level (1.0 - 7.9)
// into human-readable badges and colour classes.
//
// Business rules (agreed with the club):
//   1.0 – 1.9  → Professional / Profi
//   2.0 – 3.9  → Advanced      / Fortgeschritten
//   4.0 – 5.9  → Intermediate  / Mittelstufe
//   6.0 – 6.9  → High Beginner / Guter Anfänger
//   7.0 – 7.9  → Beginner      / Anfänger  (7.9 = complete beginner)

export const LEVEL_MIN = 1.0;
export const LEVEL_MAX = 7.9;

export const getLevelLabel = (level, lang = 'en') => {
  const l = Number(level);
  if (isNaN(l)) return '';
  if (l <= 1.9) return lang === 'de' ? 'Profi' : 'Pro';
  if (l <= 3.9) return lang === 'de' ? 'Fortgeschritten' : 'Advanced';
  if (l <= 5.9) return lang === 'de' ? 'Mittelstufe' : 'Intermediate';
  if (l <= 6.9) return lang === 'de' ? 'Guter Anfänger' : 'High Beginner';
  return lang === 'de' ? 'Anfänger' : 'Beginner';
};

// Maps numeric level → CSS colour class defined in index.css.
//   1.0 – 1.9 → level-pro          (red)
//   2.0 – 3.9 → level-advanced     (orange)
//   4.0 – 5.9 → level-intermediate (yellow)
//   6.0 – 7.9 → level-beginner     (green — covers Guter Anfänger + Anfänger)
export const getLevelBadgeClass = (level) => {
  const l = Number(level);
  if (isNaN(l)) return 'level-beginner';
  if (l <= 1.9) return 'level-pro';
  if (l <= 3.9) return 'level-advanced';
  if (l <= 5.9) return 'level-intermediate';
  return 'level-beginner';
};

// All valid half-step level values (1.0 .. 7.5) plus 7.9 for "complete beginner".
export const LEVEL_OPTIONS = [
  1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0, 5.5, 6.0, 6.5, 7.0, 7.5, 7.9,
];
